export default "__VITE_ASSET__BAkdFE4$__"